<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Merchant Config</li>
            </ol>
          </div>
          <h4 class="page-title">Merchant Config Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Merchant Configs</h4>
          <p class="sub-header">
            Create and Edit Merchant Config for your current participant
          </p>

          <div class="row">

            <div class="col-12">
              <button *ngIf="canAdd" type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary mb-1 float-right" (click)="addCardAcceptorConfig()"> Add<i class="mdi mdi-plus"></i> </button>
            </div>

            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0">
                <thead>
                  <tr>
                    <th>Merchant Config</th>
                    <th>Name</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let merchantConfig of cardAcceptorConfigs">

                    <td>{{ merchantConfig.id }}</td>
                    <td>{{ merchantConfig.name }}</td>
                    <td>
                      <button *ngIf="canView" type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="editCardAcceptorConfig(merchantConfig)">
                        <i class="mdi mdi-pencil-box-outline"></i>
                        {{EditView}}
                      </button>
                      <button *ngIf="canEdit" type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right mx-2" (click)="openDuplicationConfirmationDialog(merchantConfig)">
                        <i class="mdi mdi-content-copy"></i>
                        Copy
                      </button>
                      <button *ngIf="canEdit" type="button" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="determineDeleteDialog(merchantConfig)">
                        <i class="mdi mdi-delete"></i>
                        Delete
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
